import React, { useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';

import ServicerService from '../../services/ServicerService';
import { useServicerStore, useUiStore } from '../../store';

export default function Layout({ children, noSidebar }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });
  const isMd = useMediaQuery({ query: '(min-width: 768px)' });

  const { t } = useTranslation();

  const servicerId = useServicerStore((state) => state.servicerId);
  const userRole = useServicerStore((state) => state.userRole);
  const isBorrower = userRole === 'borrower';

  const isMainOverflowHidden = useUiStore(
    (state) => state.isMainOverflowHidden
  );

  const { data: servicer } = useQuery({
    queryKey: ['servicer', servicerId],
    queryFn: () => ServicerService.getServicer(servicerId),
    enabled: !!servicerId,
  });

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Sidebar */}
      {/* Only for mobile */}
      {isTabletOrMobile && (
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      )}

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/*  Site header */}

        <main
          className="grow flex relative z-40"
          style={{
            overflowY: isMainOverflowHidden && isMd ? 'hidden' : '',
          }}
        >
          {!noSidebar && (
            <Sidebar
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
          )}
          {/* Page content goes here */}
          <div className="grow flex flex-col">
            <Header
              isSidebarOpen={isSidebarOpen}
              setIsSidebarOpen={setIsSidebarOpen}
            />
            <div className="flex-grow relative max-w-[100vw] pl-0 lg:pl-20 2xl:pl-0 lg:sidebar-expanded:pl-48 2xl:sidebar-expanded:pl-0 ">
              {children}
            </div>
            {isBorrower && servicer && (
              <footer className="bg-white border-t border-gray-200 dark:bg-[#182235] dark:border-slate-700">
                <div className="container mx-auto p-4">
                  <div className="text-center text-gray-500 ">
                    <span className="dark:text-slate-400">
                      {t('Layout.Need help? Call us at')}
                    </span>{' '}
                    <a
                      className="text-blue-500 underline"
                      href={`tel:${servicer?._contact?.phone}`}
                    >
                      {servicer?._contact?.phone}
                    </a>{' '}
                    <span className="dark:text-slate-400">
                      {t('Layout.or email at')}
                    </span>{' '}
                    <a
                      className="text-blue-500 underline"
                      href={`mailto:${servicer?._contact?.email}`}
                    >
                      {servicer?._contact?.email}
                    </a>
                  </div>
                </div>
              </footer>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
